import styled from 'styled-components';

import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { colors, transition } from 'theme';

export const CloseButton = styled(Button)`
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.waterBlue};
  }
`;
